import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UpgradeDialogComponent } from '../upgrade-dialog/upgrade-dialog.component';
import { Constant } from '../../constant';

@Component({
  selector: 'app-update-notification',
  templateUrl: './update-notification.component.html',
  styleUrls: ['./update-notification.component.scss']
})
export class UpdateNotificationComponent implements OnInit {
  showNotification: boolean = false;
  currentVersion: string = '';
  isVisible: boolean = false;
  lastSeenVersion: string | null = null;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private constant: Constant
  ) {}

  ngOnInit(): void {
    // Obtener la versión actual desde el servicio centralizado
    this.currentVersion = this.constant.version;
    this.checkForUpdates();
  }

  checkForUpdates(): void {
    // Obtener la última versión vista por el usuario desde localStorage
    this.lastSeenVersion = localStorage.getItem('lastSeenVersion');

    // Si no hay versión vista o la versión actual es diferente, mostrar notificación
    if (!this.lastSeenVersion || this.lastSeenVersion !== this.currentVersion) {
      this.showUpdateNotification();
    }
  }

  showUpdateNotification(): void {
    this.showNotification = true;

    // Mostrar la notificación después de un pequeño delay para una mejor experiencia
    setTimeout(() => {
      this.isVisible = true;
    }, 2000);

    // Auto-ocultar después de 15 segundos (opcional)
    setTimeout(() => {
      this.autoHide();
    }, 15000);
  }

  verActualizaciones(): void {
    // Marcar la versión actual como vista
    localStorage.setItem('lastSeenVersion', this.currentVersion);

    // Abrir el diálogo de actualizaciones
    const dialogRef = this.dialog.open(UpgradeDialogComponent, {
      width: '90vw',
      maxWidth: '800px',
      height: 'auto',
      maxHeight: '90vh',
      disableClose: false,
      hasBackdrop: true,
      backdropClass: 'upgrade-dialog-backdrop',
      panelClass: 'upgrade-dialog-panel',
      data: {
        version: this.currentVersion
      }
    });

    // Opcional: hacer algo cuando se cierre el diálogo
    dialogRef.afterClosed().subscribe(result => {
      console.log('Diálogo de actualizaciones cerrado');
    });

    this.hideNotification();
  }

  hideNotification(): void {
    this.isVisible = false;
    setTimeout(() => {
      this.showNotification = false;
    }, 300);
  }

  autoHide(): void {
    if (this.isVisible) {
      this.isVisible = false;
      setTimeout(() => {
        this.showNotification = false;
      }, 300);
    }
  }

  // Método para marcar como vista sin navegar (para el botón X)
  markAsSeenAndHide(): void {
    localStorage.setItem('lastSeenVersion', this.currentVersion);
    this.hideNotification();
  }
}
